import TooltipIcon from "../TooltipIcon";

const GENERATED_BY_AI_MESSAGE =
  "This content is AI generated (GPT 4.1 and 4o). Review for accuracy before relying on it.";

const AIGeneratedIcon = () => (
  <TooltipIcon
    icon="ai-generated"
    message={GENERATED_BY_AI_MESSAGE}
    placement="top"
    dimensions={18}
    tooltipClassName="tooltip--wide"
  />
);

export default AIGeneratedIcon;
